// extracted by mini-css-extract-plugin
export default {"layout":"layout___IDT7V","columns":"columns___RMF5m","sidebar":"sidebar___KhPmo","content":"content___qeERG"};